import * as React from "react";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import StatusMessage from "../../../presentational/StatusMessage";
import AccountNewForm from "../../../forms/public/AccountNewForm";
import { Link } from "react-router";
const NewUser = (props) => (<div className="new-user">
		<div className="vr vr_x4">
			<h2 className="hdg">
				<FormattedMessage id="login.newUserHeader" defaultMessage="New User"/>
			</h2>
		</div>

		{props.children}

		<StatusMessage isError isActive={props.validationError ? true : false} error={props.validationError ? props.validationError : null} customMessage={StatusMessages.VALIDATION.INTRO_NEW_ACCOUNT} domain="validation"/>

		<div className="vr vr_x3">
			<AccountNewForm create={props.confirmNewAccount} fieldErrors={props.validationFieldErrors} isLoading={props.validationIsLoading}/>
		</div>
		<StatusMessage isLoad isActive={props.validationIsLoading ? true : false}/>
		<div className="vr vr_x5">
			<div className="text">
				<p>
					<FormattedMessage id="login.unknownReference" defaultMessage="Don’t know your Reference/File number or PIN?"/>
				</p>
				<p>
					<Link className="link" to="/public/contact">
						<FormattedMessage id="login.unknownReference.contact" defaultMessage="Contact Us"/>
					</Link>
				</p>
			</div>
		</div>
	</div>);
export default NewUser;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/NewUser.tsx